import $ from 'jquery'

window.jQuery = window.$ = $
import('./common')
